import { FC } from 'react';

import { Icon, IconProps, isValidIconName } from '@eluve/components';

/** SDUI specs use a different size scale than the Icon component. */
type SduiIconSize = 'xs' | 'sm' | 'md' | 'lg';

const sduiSizeMap: Record<SduiIconSize, IconProps['size']> = {
  xs: 'md',
  sm: 'lg',
  md: 'xl',
  lg: '2xl',
};

export interface IconRendererProps {
  name: string;
  size?: SduiIconSize;
}

export const IconRenderer: FC<IconRendererProps> = ({ name, size }) => {
  if (!isValidIconName(name)) return null;
  const mappedSize = size ? sduiSizeMap[size] : undefined;
  return <Icon name={name} size={mappedSize} />;
};
